define('SageDotCom/DataLayer/Events/video-interaction',[
    'SageDotCom/DataLayer/Events/eventBase'
], function (EventBase) {

    function VideoInteractionEvent(player, isMilestoneEvent) {
        EventBase.call(this);

        this.props = {
            'event_name': 'video_int',
            'event_non-int': '0',
            'event_category': 'engagement',
            'event_action': 'video',
            'event_label': isMilestoneEvent ? 'milestone' : getStateLabel(player),
            'event_name_level_1': getVideoId(player),
            'event_name_level_2': getMilestone(player, isMilestoneEvent),
            'event_name_level_3': getVideoTitle(player),
            'event_name_level_4': '(not set)'
        };
    }

    VideoInteractionEvent.prototype = Object.create(EventBase.prototype);

    function getStateLabel(player) {
        if (player.isYoutube) {
            switch (player.getPlayerState()) {
            case YT.PlayerState.PLAYING:
                return 'play';
            case YT.PlayerState.PAUSED:
                return 'pause';
            case YT.PlayerState.ENDED:
                return 'end';
            default:
                return '(not set)';
            }
        }
        else if (player.isBrightcove) {
            switch (player.eventType) {
                case "play":
                    return "play";
                case "pause":
                    return "pause";
                case "ended":
                    return "end";
                case "milestone":
                    return "milestone";
                default:
                    return "(not set)";
            }
        }
        else {
            return player.tracking.eventType;
        }
    }

    function getVideoId(player) {
        if (player.isYoutube) {
            return player.getIframe().id;
        }
        else if (player.isBrightcove) {
            return player.videoId;
        }
        else {
            return player.tracking.id;
        }
    }

    function getVideoTitle(player) {
        if (player.isYoutube) {
            return player.getVideoData().title;
        }
        else if (player.isBrightcove) {
            return player.videoTitle;
        }
        else {
            return player.tracking.title;
        }
    }

    function getMilestone(player, isMilestoneEvent) {
        if (isMilestoneEvent) {
            if (player.isBrightcove) {
                return player.milestone;
            }
            else {
                return player.tracking.milestone.toString();
            }
        }
        else {
            return '(not set)';
        }
    }

    return VideoInteractionEvent;
});
